package net.frozenbit.games.soundgame.ui

import androidx.compose.animation.AnimatedContentScope
import androidx.compose.animation.SharedTransitionScope
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.visible
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.components.CountdownTimer
import net.frozenbit.games.soundgame.components.JoinCode
import net.frozenbit.games.soundgame.components.PlayerTag
import net.frozenbit.games.soundgame.components.Prompt
import net.frozenbit.games.soundgame.components.QuarterArc
import net.frozenbit.games.soundgame.theme.Dimensions
import net.frozenbit.games.soundgame.utils.Countdown
import net.frozenbit.games.soundgame.viewmodels.HostViewModel
import net.frozenbit.games.soundgame.viewmodels.presentation.PlayerTagData

context(screenTransitions: AnimatedContentScope)
@Composable
fun SharedTransitionScope.HostSoundSelectionScreen(
    joinCode: String,
    who: PlayerTagData,
    participants: List<HostViewModel.HostUiState.SoundSelection.Participant>,
    countdownText: Countdown.Tick?,
    promptText: String,
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .fillMaxSize()
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(Dimensions.Host.bigInnerPadding, Alignment.Top),
            modifier = Modifier
                .padding(8.dp)
        ) {
            Prompt(
                promptText,
                modifier = Modifier.sharedElement(
                    rememberSharedContentState(key = "prompt"),
                    screenTransitions,
                )
            )
            if (countdownText != null) {
                CountdownTimer(countdownText)
            } else {
                Spacer(modifier = Modifier.height(100.dp))
            }
            FlowRow(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.CenterHorizontally),
            ) {
                participants.forEach { participant ->
                    PlayerTag(
                        participant.player,
                        modifier = Modifier.visible(!participant.picked),
                    )
                }
            }
        }
        QuarterArc(
            modifier = Modifier
                .align(Alignment.BottomStart)
        )
        Box(
            modifier = Modifier
                .align(Alignment.BottomStart)
                .padding(16.dp)
        ) {
            PlayerTag(
                who,
                modifier = Modifier.sharedElement(
                    rememberSharedContentState(key = "jury"),
                    screenTransitions,
                )
            )
        }
        JoinCode(
            joinCode,
            modifier = Modifier
                .align(Alignment.BottomEnd)
                .padding(16.dp)
        )
    }
}